import 'bootstrap';
import 'devbridge-autocomplete';
import 'slick-carousel/slick/slick.min';
import './js/scripts';

import './scss/app.scss';

const $ = require("jquery");
window.jQuery = $;
window.$ = $;